import { useState } from 'react'

import { useIntl } from '@/intl'
import { durationUtils } from '@/server-data'

const formatSetupCost = (setupCost: number): string => `${(setupCost / 100).toFixed(2)}`

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    edit: {
      tooltip: translate({ id: 'global.edit' }),
      title: translate({ id: 'global.edit' }),
    },
    delete: {
      tooltip: (disabled: boolean) =>
        disabled
          ? translate({ id: 'setup.depots.delete.disabledSinceLinked', values: { count: 1 } })
          : translate({ id: 'global.delete' }),
      title: translate({ id: 'global.delete' }),
    },
    labels: {
      address: translate({ id: 'setup.depots.address' }),
      setupCost: translate({ id: 'setup.depots.setupCost' }),
      setupTime: translate({ id: 'setup.depots.setupTime' }),
    },
    values: {
      setupCost: (cost: number, currency: string) => {
        return cost > -1
          ? translate({
              id: 'setup.depots.view.setupCost',
              values: { cost: formatSetupCost(cost), currency },
            })
          : translate({ id: 'setup.depots.list.noSetupCost' })
      },
      setupTime: (seconds: number) => {
        return seconds > -1
          ? durationUtils.formatSeconds(translate)(seconds, 'SHORT')
          : translate({ id: 'setup.depots.list.noSetupTime' })
      },
    },
  }))

  return api
}
